import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { gettime, gettime2 } from '../../utils/time'
import Rectangle2 from "../../static/img/Rectangle2.png"
import jx4 from '../../static/img/jx4.png'
import { useParams } from "react-router";
import { getevent, papticipants, goto, recommendations, eventperson, getsystemlis, goevent, getperson, getwhether,getindustryType } from '../../utils/api'
import { InfiniteScroll } from 'antd-mobile'
import { Cell, Loading } from '@nutui/nutui-react';
import { Toast } from 'zarm';
import { cardurl } from '../../utils/constants'
import bg1 from '../../static/bg/card_image_1_0.png'
import bg2 from '../../static/bg/card_image_1_0.png'
import bg3 from '../../static/bg/card_image_1_0.png'
import bg4 from '../../static/bg/card_image_1_0.png'
import { IconFont } from '@nutui/icons-react-taro'
import Loading2 from '../../static/img/lo.png'


const icon = {
    width: '14px',
    height: '14px',
    marginLeft: '5px',
    marginRight: '5px',
}

const sy = {
    overflow: 'hidden',
    height: '50vh'
}

const sy2 = {
    overflow: 'hidden',
    height: '100%'
}


const blue = {
    borderLeft: '10px solid #4AABEC',
    color: '#4AABEC',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'

}
const pink = {
    borderLeft: '10px solid #E21CAE',
    color: '#E21CAE',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}
const green = {
    borderLeft: '10px solid #6AEC87',
    color: '#6AEC87',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}
const yellow = {
    borderLeft: '10px solid #FFC932',
    color: '#FFC932',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}
const orange = {
    borderLeft: '10px solid #FD8B86',
    color: '#FD8B86',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}


const EventDetails: React.FC = () => {
    const { t } = useTranslation()
    // const params = useParams()
    const [search, setsearch] = useSearchParams()

    const [event, getevents] = useState([]) as any;

    // const [eventid, seteventid] = useState([]) as any;
    let eventref = useRef([]) as any;

    useEffect(() => {
        eventref.current = event
    }, [event])

    const [transformdeg, settransformdeg] = useState(0)
    let transformdegRef = useRef(0);
    useEffect(() => {
        transformdegRef.current = transformdeg
    }, [transformdeg])

    const [ogList, geogList] = useState([]) as any;
    const [bespeak, getbespeak] = useState(false);
    const [bespeak2, getbespeak2] = useState(true);
    const [go, getgo] = useState(false);

    const [tit, settit] = useState(true)
    const [tit2, settit2] = useState(true)

    // const [papticipant, setpapticipant] = useState([]) as any;
    const [LOADING, setLOADING] = useState(true);
    // let papticipantRef = useRef([]) as any;


    let [num, setNum] = useState(0)



    const Directions = (url: any) => {


        if (url === null) {
            Toast.show(t('Notyetstarted'));
        } else {
            // window.location.assign(url); 
            window.open(url);
        }
    };



    const [sdmUserId, setsdmUserId] = useState('');
    let sdmUserIdref = useRef('')
    useEffect(() => {
        sdmUserIdref.current = sdmUserId
    }, [sdmUserId])

    const getRoomInfo = (url: string) => {


        if (url === null) {
            Toast.show(t('Therearecurrentlynogroupchatsavailable'));
        } else {
            // window.location.assign(url); 
            window.open(url);
        }
    };


    let [total, settotal] = useState(0)
    let totalref = useRef(total);
    useEffect(() => {
        totalref.current = total
    }, [total])

    const getDate = async () => {
        // papticipantRef.current = []
        // setpapticipant(papticipantRef.current)

        businessCardRef.current = []
        setbusinessCard(businessCardRef.current)

        sysRef.current = []
        setsys(sysRef.current)
        currentRef.current = 0
        setcurrent(currentRef.current)
        await getevent({
            // id: params.eventId,
            id: search.get("eventId"),
            userid: sdmUserIdref.current
        }).then((res) => {
            res.data.event.time = gettime(res.data.event.eventStartTime, res.data.event.eventEndTime)

            // systemlis(res.data.event.eventId)

            if (res.data.event.industryId) {
                getindustryType({
                    industryId: res.data.event.industryId
                }).then((re) => {
                    res.data.event.industryLabel = re.data.industryName
                })
            }

            sysstatusref.current.forEach((item: any) => {
                console.log(item.dictLabel,'dictLabel')
                if (item.dictValue == res.data.event.eventType) {
                    console.log(item.dictLabel,'dictLabel')
                    res.data.event.state = item.dictLabel
                }
            })

            if(res.data.event.keywords){
                let arr = res.data.event.keywords.split('##')
                res.data.event.keywordsmap = arr
            }
          
            getevents(res.data.event)

            if (res.data.finish) {
                Toast.show(t('Thecurrentactivityhasended'));
            }

            res.data.ogList.forEach((item :any) => {
                item.headImg = item.headImg.replace('http:','https:')
            })
            geogList(res.data.ogList)
            getgo(res.data.go)

            papticipantsData(res.data.event.eventId)
            getDate2(res.data.event.eventId)
           
        }
        );
    }

    const containerRef = useRef(null) as any;
    // const container = containerRef.current;
    const handleScroll = () => {
        if (containerRef.current.scrollTop + containerRef.current.clientHeight >= containerRef.current.scrollHeight) {
            papticipantsData(eventref.current.eventId)

        }
    };


    const whether = async () => {
        await getwhether({
            sdmUserId: sdmUserIdref.current,
            eventId: search.get("eventeventId"),
        }).then((res) => {
            if (!res.data.go) {
                goto({
                    sdmUserId: sdmUserIdref.current,
                    eventId: search.get("eventeventId")
                }).then((res) => {

                });
            }
        })
    }




    useEffect(() => {
        // console.log(search.get("pid"),'pid')
        window.scrollTo(0, 0);
        document.body.style.overflow = 'auto'
        systemlis()
        let data3: any = []
        data3 = localStorage.getItem('userinformation')
        data3 = JSON.parse(data3)
        sdmUserIdref.current = data3.userId
        getDate()
        containerRef.current.addEventListener('scroll', handleScroll);



        // return () => {
        //     containerRef.current.removeEventListener('scroll', handleScroll);
        // };

        // document.addEventListener('scroll', scrollEvent)
        // return () => {
        //     document.removeEventListener('scroll', scrollEvent);
        // };
    }, []);


    const cusBgNotify = (message: string) => {
        console.log(message)
        Toast.show(message);
    }






    const getshow = () => {
        getbespeak(false)
        getbespeak2(false)
        goto({
            sdmUserId: sdmUserIdref.current,
            eventId: event.eventId
        }).then((res) => {
            console.log(res)
            if (res.code == 200) {
                getgo(true)
                getDate()
                whether()
            } else {
                cusBgNotify(res.msg)
            }

        });
        document.body.style.overflow = 'auto'
    }

    const ScrollContext2 = () => {
        getbespeak(true)
        document.body.style.overflow = 'hidden';
    }


    const ScrollContext = () => {
        // getgo(true)
        getbespeak(false)
        document.body.style.overflow = 'auto'
    }

    let [sysstatus, setsysstatus] = useState([]) as any

    let sysstatusref = useRef(sysstatus);

    useEffect(() => {
        sysstatusref.current = sysstatus
    }, [sysstatus])



    const systemlis = async () => {
        await getsystemlis('sys_event_status').then((res) => {
            // eventgetDate(res.data)
            // getDate2(res.data, id)
            sysstatusref.current = res.data
            setsysstatus(sysstatusref.current)
        }
        );
    }
    const [activity, getactivity] = useState([]) as any;

    const getDate2 = async ( id: number) => {
        await goevent({
            eventId: id,
            sdmUserId: sdmUserIdref.current
        }).then((res) => {

            sysstatusref.current.forEach((item: any) => {
                res.data.forEach((item2: any) => {
                    if (item2.eventType == item.dictValue) {
                        item2.status = item.dictLabel
                    }
                })
            });

            let color = ['4AABEC', 'E21CAE', 'FD8B86', 'FD8D10', 'FFC932', '6AEC87', '76A534', '9F6FFF', 'E97190', '7483C4']

            res.data.forEach((item: any) => {
                item.eventcolors = color[Number(item.eventType) - 1]
                item.time = gettime2(item.eventStartTime, item.eventEndTime)
            });



            getactivity(res.data)
        }
        );
    }



    const color16 = () => {
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        // var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
        var color = 'rgb(' + r + ',' + g + ', ' + b + ')';
        return color
    }

    const goBackPage = () => {
        window.history.back()
    }

    const [currentnum, setcurrent] = useState(0);

    let currentRef = useRef([]) as any;
    useEffect(() => {
        currentRef.current = currentnum
    }, [currentnum])

    const Jumptobusinesscard = (id: any) => {



        if (id === null) {
            Toast.show(t('Nobusinesscard'));
        } else {
            const url = cardurl + '?st=sdn&id=' + id
            console.log(url)
            // const url = `https://businesscard.web3-tp.net/detail?st=sdn&id=cb6c9a0f0e6a4a0198c15ad1eb88b850`
            window.location.assign(url);

        }





    }

    const [businessCard, setbusinessCard] = useState([]) as any;
    let businessCardRef = useRef([]) as any;

    const [sys, setsys] = useState([]) as any;
    let sysRef = useRef([]) as any;

    useEffect(() => {
        businessCardRef.current = businessCard
    }, [businessCard])

    useEffect(() => {
        sysRef.current = sys
    }, [sys])





    const [showhasMore, setshowhasMore] = useState(false)

    const papticipantsData = async (eventId: any) => {

        const setdge = setInterval(function () {
            transformdegRef.current = transformdegRef.current * 1 + 20
            settransformdeg(transformdegRef.current)
            console.log(transformdegRef.current)
        }, 100);

        // console.log('1111111111')
        // console.log(currentRef.current)
        setshowhasMore(true)
        currentRef.current = currentRef.current + 1
        await getperson(eventId, {
            // eventId:eventId,
            current: currentRef.current,
            pageSize: 10
        }).then((res) => {

            // await getperson(eventId).then((res) => {
            if (res.data) {

                // getuserinformation(res.data)
                let data2: any = []
                data2 = localStorage.getItem('getMyContacts')
                data2 = JSON.parse(data2)
                let Frienddata = data2 ? data2 : []


                res.data.businessCard.forEach((item2: any) => {
                    item2.color = color16()
                    if (item2.layoutType == 1) {
                        item2.bgimg = bg1
                        // item2.bgimg = 'https://businesscard.socialswap.com/image/icon/card_image_1_0.png'
                    } else if (item2.layoutType == 3) {
                        item2.bgimg = bg2
                        // item2.bgimg  = 'https://businesscard.socialswap.com/image/icon/card_image_2_0.png'
                    } else if (item2.layoutType == 5) {
                        item2.bgimg = bg3
                        // item2.bgimg  = 'https://businesscard.socialswap.com/image/icon/card_image_3_0.png'
                    } else if (item2.layoutType == 7) {
                        item2.bgimg = bg4
                        // item2.bgimg  = 'https://businesscard.socialswap.com/image/icon/card_image_4_0.png'
                    }


                    item2.userImg = item2.userImg + ''
                    Frienddata.forEach((item: any) => {
                        if (item.userId == item2.linxUserId) {
                            item2.friend = 1

                        }
                    })
                });

                Frienddata.forEach((item: any) => {
                    res.data.sys.forEach((item2: any) => {
                        item2.color = color16()
                        item2.imgUrl = item2.imgUrl + ''
                        if (item.userId == item2.linxUserId) {
                            item2.friend = 1

                        }
                    })
                });



                if (res.data.businessCard.length > 0 || res.data.sys.length > 0) {



                    let tmp = businessCardRef.current
                    tmp.push(...res.data.businessCard)
                    tmp.forEach((item: any) => {
                        item.userImg = item.userImg.replace('http:','https:')
                    })
                    setbusinessCard([...tmp])

                    let tmp2 = sysRef.current
                    tmp2.push(...res.data.sys)
                    setsys([...tmp2])
                    setLOADING(false)
                } else {
                    console.log(1111)
                    setLOADING(false)
                    return false
                }
            } else {

            }
        })
        clearTimeout(setdge);
    }

    const [dragDistance, setDragDistance] = useState(0); // 记录拖动距离的状态变量

    const [dragDistance2, setDragDistance2] = useState(0);

    let dragDistanceRef = useRef(0)
    useEffect(() => {
        dragDistanceRef.current = dragDistance
    }, [dragDistance])

    let dragDistanceRef2 = useRef(0)
    useEffect(() => {
        dragDistanceRef2.current = dragDistance2
    }, [dragDistance2])

    const [initialXPosition, setinitialXPosition] = useState(0)

    const handleMouseMove = (event: any) => {
        if (!event.buttons || event.button !== 0) return; // 只有在鼠标左键被按住时才会触发拖动
        let ogListW = ogList.length * -90
        const currentXPosition = event.clientX; // 获取鼠标相对于页面左边界的位置
        const draggedDistance = currentXPosition - initialXPosition; // 计算拖动距离
        const draggedDistance2 = draggedDistance + dragDistanceRef2.current

        if (draggedDistance2 < 1 && draggedDistance2 > ogListW) {
            dragDistanceRef.current = draggedDistance2
            setDragDistance(dragDistanceRef.current);
        }
        // 更新拖动距离的状态变量
    };

    const handleMouseDown = (event: any) => {

        setinitialXPosition(event.clientX)
        window.addEventListener('mousemove', handleMouseMove); // 注册鼠标移动事件监听器
        window.addEventListener('mouseup', handleMouseUp); // 注册鼠标松开事件监听器
    };

    const handleMouseUp = () => {
        dragDistanceRef2.current = dragDistanceRef.current
        setDragDistance2(dragDistanceRef2.current)
        window.removeEventListener('mousemove', handleMouseMove); // 移除鼠标移动事件监听器
        window.removeEventListener('mouseup', handleMouseUp); // 移除鼠标松开事件监听器
    };


    const cusBgNotify2 = () => {

        // if (localStorage.getItem('lang') == 'zh') {
        //     Toast.show('当前活动已结束');
        // } else {
        Toast.show(t('Thecurrentactivityhasended'));
        // }

    }

    const [hasMore, setHasMore] = useState(true)
    async function loadMore() {

    }

    return <div style={{ backgroundColor: "#202225", color: '#fff', position: 'relative' }}>
        {LOADING && <div style={{ width: '100%', height: '100vh', backgroundColor: '#000', zIndex: 99999, position: 'fixed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <IconFont name={Loading2} size="80" style={{ transform: `rotate(${transformdeg}deg)` }} />
            {/* <Loading direction="vertical" type="spinner"></Loading> */}
        </div>

        }
        {bespeak && <div style={{ backgroundColor: '#000', width: '100%', height: '100%', zIndex: 1000, opacity: 0.5, position: 'absolute' }}>
        </div>}
        {bespeak && <div style={{
            alignItems: 'center', backgroundColor: '#37383D', width: '100%', zIndex: 1001, position: 'fixed', bottom: '0',
            borderTopRightRadius: '20px', borderTopLeftRadius: '20px'
        }}>
            <div style={{ height: '64px' }}>
                <div style={{ color: '#BABBBE', lineHeight: '64px', textAlign: 'center', fontSize: '15px', fontWeight: 500 }}>{t('Schedulepreview')}</div>
            </div>
            {
                activity.length > 0 ?
                    <div style={{ overflow: 'hidden', height: '55vh', width: '105vw' }}>
                        <div style={{ overflow: 'auto', height: '100%', overflowY: 'scroll' }}>
                            {
                                activity.map((item: any, index: any) =>
                                    <div key={index}  >
                                        <div style={{
                                            borderLeft: '10px solid',
                                            borderLeftColor: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'),
                                            color: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'),
                                            backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
                                        }}  >
                                            <div style={{ margin: 10, display: 'flex', flexDirection: 'row' }}>
                                                <div style={{ fontSize: '12px', lineHeight: '14px', height: '14px', fontWeight: 500, marginRight: '10px', color: '#ffF' }}>
                                                    {/* {item.eventEndTime} */}
                                                    {item.time}
                                                </div>
                                                <div style={{ fontSize: '12px', lineHeight: '14px', height: '14px', fontWeight: 500 }}>{item.status}</div>
                                            </div>
                                            {/* <div style={{
                                                fontSize: '16px', lineHeight: '19px', height: '19px', fontWeight: 600, color: '#ffF', marginLeft: '10px', overflow: 'hidden',
                                                textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', width: '65vw'
                                            }}>
                                                {item.eventName}
                                            </div> */}
                                              <div style={{
                                                fontSize: '16px', lineHeight: '19px', height: '19px', fontWeight: 600, color: '#ffF', marginLeft: '10px', overflow: 'hidden',
                                                textOverflow: 'ellipsis', width: '65vw' ,whiteSpace: 'nowrap'
                                            }}>
                                                {item.eventName}
                                            </div>
                                            <Link to={`/plat2?longitude=${item.longitude}&latitude=${item.latitude}&eventLocation=${item.eventLocation}&eventName=${item.eventName}&time=${item.time}&eventId=${item.eventId}`}
                                                style={{ color: '#FFF', textDecorationLine: 'none' }}
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', height: '14px', margin: '10px' }}>
                                                        <img src={require("../../static/img/ph_map-pin.png")} style={{ width: '14px', height: '14px', justifyContent: 'center' }}></img>
                                                        <div style={{ fontSize: '12px', lineHeight: '14px', fontWeight: 500, color: '#BCAFFF', marginLeft: '5px', borderColor: '#BCAFFF', borderBottomWidth: 1, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '65vw' }}>
                                                            {item.eventLocation}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        {index != activity.length - 1 && <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px', marginLeft: '50px', marginBottom: '10px', marginRight: '50px' }}>
                                            <div style={{ marginRight: '10px' }}>
                                                <div style={{ height: 6, width: 6, backgroundColor: '#38CA9F', borderRadius: '3px', marginTop: '-2.5px' }}></div>
                                                <div style={{ height: '100%', borderLeft: '1px dashed #38CA9F', marginLeft: '2px' }}></div>
                                                <div style={{ height: 6, width: 6, backgroundColor: '#38CA9F', borderRadius: '3px', marginTop: '-2.5px' }}></div>
                                            </div>
                                            {/* <div style={{ color: '#38CA9F', textAlign: 'center', margin: '5px', fontSize: '12px', flexWrap: 'wrap' }}>
                                                {t('InternationalTravelPlanyouritinerarywell')}
                                            </div> */}

                                            {
                                                activity[index].eventCountry != activity[index + 1].eventCountry ? <div style={{ color: '#38CA9F', textAlign: 'center', margin: '5px', fontSize: '12px', flexWrap: 'wrap' }}>
                                                    {t('InternationalTravelPlanyouritinerarywell')}
                                                </div> : <div style={{ color: '#38CA9F', textAlign: 'center', margin: '5px', fontSize: '12px', flexWrap: 'wrap', height: '20px' }}>

                                                </div>
                                            }
                                        </div>}


                                    </div>

                                )
                            }
                        </div>
                    </div> : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                        <img src={require("../../static/img/Frame.png")} style={{ width: '206px', height: '158px', margin: '20px' }} alt="" />
                        <span style={{ fontSize: '16px', fontWeight: 500, height: '22.5px', lineHeight: '22.5px' }}> There are currently no itinerary conflicts</span>
                    </div>
            }
            <div style={{ display: 'flex', flexDirection: 'row', margin: '20px', marginTop: '40px' }}>
                <div style={{ flex: 1, alignItems: 'center', marginRight: '10px' }}>
                    <div style={{
                        backgroundColor: '#45474D', height: '48px', lineHeight: '48px',
                        borderRadius: '10px', textAlign: 'center', fontSize: '16px', fontWeight: 500, color: '#FFF', cursor: 'pointer'
                    }} onClick={() => ScrollContext()}>{t('Cancel')}</div>
                </div>
                <div style={{ flex: 1, alignItems: 'center', marginLeft: '10px' }}>
                    <div style={{
                        backgroundColor: '#735BF2', height: '48px', lineHeight: '48px',
                        borderRadius: '10px', textAlign: 'center', fontSize: '16px', fontWeight: 500, color: '#FFF', cursor: 'pointer'
                    }} onClick={() => getshow()}>{t('Iwillgo')}</div>
                </div>
            </div>
        </div>}

        {/*  */}
        <div style={{ backgroundImage: `url(${event.eventBanner})`, backgroundSize: '100%,100%', backgroundRepeat: 'no-repeat', borderTopRightRadius: '20px', borderTopLeftRadius: '20px' }}>
            {/* <div style={{ backgroundImage: `url(${event.eventBanner})`, width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}> */}

            <div style={{ backgroundImage: 'linear-gradient(to top,#202225, rgba(255, 255, 255, 0.1))' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <img src={require("../../static/img/xljt.png")} style={{ width: '24px', height: '24px', marginTop: '20px', marginLeft: '10px', cursor: 'pointer' }} onClick={() => goBackPage()}></img>
                </div>
                <div style={{ marginLeft: '20px', }}>
                    {
                        tit ? <div style={{
                            color: '#FFFFFF', fontSize: '32px', fontWeight: 700, marginTop: '40px', overflow: 'hidden',whiteSpace: 'nowrap'
                            , textOverflow: 'ellipsis', width: '95%'
                        }} onClick={() => settit(false)} >{event.eventName}</div> :
                            <div style={{ color: '#FFFFFF', fontSize: '32px', fontWeight: 700, marginTop: '40px', width: '95%', wordWrap: 'break-word', whiteSpace: 'normal' }} onClick={() => settit(true)}>{event.eventName}</div>
                    }

                    <div style={{
                        color: '#FFFFFF', fontSize: '14px', marginTop: '15px', display: 'flex',
                        alignItems: 'center',marginLeft:'-5px'
                    }}>
                        <img src={require("../../static/img/Date2.png")} style={icon}></img>  {event.time}
                    </div>
                    <Link to={`/plat2?longitude=${event.longitude}&latitude=${event.latitude}&eventLocation=${event.eventLocation}&eventName=${event.eventName}&time=${event.time}&eventId=${event.eventId}`}
                        style={{ color: '#FFF', textDecorationLine: 'none' }}
                    >
                        <div style={{
                            color: '#FFFFFF', fontSize: '14px', marginTop: '10px', marginBottom: '10px', display: 'flex',
                            alignItems: 'center',marginLeft:'-5px'
                        }}>
                            <img src={require("../../static/img/ph_map-pin2.png")} style={icon}></img>
                            <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{event.eventLocation}</span>
                        </div>
                    </Link>
                    {
                        event.eventOrganizer && <div style={{
                            color: '#FFFFFF', fontSize: '14px', marginBottom: '10px', display: 'flex',
                            alignItems: 'center',marginLeft:'-5px'
                        }}>
                            <img src={require("../../static/img/yingyongguanliyuanguanli.png")} style={icon}></img><div style={{ paddingRight: '10px',width: '75vw', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',  }}>{event.eventOrganizer}({t('Organizer')})</div>
                        </div>
                    }
                    {
                         tit2 ? <div style={{
                            fontSize: '14px', color: '#BABBBE', marginRight: '20px', lineHeight: '25px', width: '95%', overflow: 'hidden',
                            textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', marginTop: '10px',

                        }} onClick={() => settit2(false)}>{event.eventDescribe}</div> :
                            <div style={{
                                fontSize: '14px', color: '#BABBBE', marginRight: '20px', lineHeight: '25px', wordWrap: 'break-word',
                                whiteSpace: 'normal', marginTop: '10px',
                            }} onClick={() => settit2(true)}>{event.eventDescribe}</div>
                    }

                </div>
            </div>
        </div>


        {ogList.length > 0 &&
            <div onMouseDown={handleMouseDown}>
                <div style={{ marginLeft: '20px', marginTop: '20px', color: '#BABBBE', fontSize: '14px' }} >
                    {t('Speaker')}
                </div>
                {/* {dragDistance}px */}
                {

                    ogList.length > 3 ? <div style={{ display: 'flex', flexDirection: 'row', width: '100%', overflowX: 'scroll' }}>
                        {ogList.map((item: any, index: any) => <div style={{ margin: '20px' }} key={index} >
                            <img src={item.headImg} style={{ width: '90px', height: '90px', justifyContent: 'center', borderRadius: '45px', display: item.headImg ? 'block' : 'none' }}></img>
                            <div style={{ fontSize: '14px', height: '12px', lineHeight: '12px', color: "#fff", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogName}</div>
                            <div style={{ fontSize: '12px', height: '10px', lineHeight: '10px', fontWeight: 400, color: "#999999", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogCompany}</div>
                        </div>)}

                    </div> : <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        {ogList.map((item: any, index: any) => <div style={{ margin: '20px' }} key={index} >
                            <img src={item.headImg} style={{ width: '90px', height: '90px', justifyContent: 'center', borderRadius: '45px', display: item.headImg ? 'block' : 'none' }}></img>
                            <div style={{ fontSize: '14px', height: '12px', lineHeight: '12px', color: "#fff", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}> {item.ogName}</div>
                            <div style={{ fontSize: '12px', height: '10px', lineHeight: '10px', fontWeight: 400, color: "#999999", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogCompany}</div>
                        </div>)}

                    </div>
                }
                {/* <div style={{ overflow: 'hidden' }}  >
                    <div id="hansor" style={{ display: 'flex', flexDirection: 'row', width: '100%', transform: `translateX(${dragDistance}px)` }}>
                        {ogList.map((item: any, index: any) => <div style={{ margin: '20px' }} key={index} >
                            <img draggable="true" src={item.headImg} style={{ width: '90px', height: '90px', justifyContent: 'center', borderRadius: '45px', display: item.headImg ? 'block' : 'none' }}></img>
                            <div style={{ fontSize: '14px', height: '12px', lineHeight: '12px', color: "#fff", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogName}</div>
                            <div style={{ fontSize: '12px', height: '10px', lineHeight: '10px', color: "#999999", textAlign: 'center', width: '90px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.ogCompany}</div>
                        </div>)}
                    </div>
                </div> */}
            </div>
        }

        <div style={{ fontSize: '14px', color: '#9E8BFF', marginTop: '10px', marginLeft: '20px', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => Directions(event.officialWebsiteLink)}>{t('Learnmorefromofficialwebsite')}</div>
        {/* {event.keywords && <div style={{ display: 'flex', flexDirection: 'row', height: '26px', marginLeft: '20px', lineHeight: '6px', marginTop: '10px' }}>
            <div style={{ marginRight: '10px', borderRadius: '13px', color: '#fff', backgroundColor: '#FFFFFF4D', padding: '10px' }}>{event.keywords}</div>
          
        </div>
        
        } */}
        <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '20px', flexWrap: 'wrap' }}>
            {event.keywords &&
                event.keywordsmap.map((item: any, index: any) => <div>{item &&
                    <div key={index} style={{ display: 'flex', flexDirection: 'row', height: '26px', lineHeight: '6px', marginTop: '10px' }}>
                        <div style={{ marginRight: '10px', borderRadius: '13px', color: '#fff', backgroundColor: '#FFFFFF4D', padding: '10px',maxWidth: '50vw', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', }}>{item}</div>
                    </div>}
                </div>
                )
            }
            {event.state &&
                <div style={{ display: 'flex', flexDirection: 'row', height: '26px', lineHeight: '6px', marginTop: '10px' }}>
                    <div style={{ marginRight: '10px', borderRadius: '13px', color: '#fff', backgroundColor: '#FFFFFF4D', padding: '10px' }}>{event.state}</div>
                </div>

            }
            {event.industryLabel &&
                <div style={{ display: 'flex', flexDirection: 'row', height: '26px', lineHeight: '6px', marginTop: '10px' }}>
                    <div style={{ marginRight: '10px', borderRadius: '13px', color: '#fff', backgroundColor: '#FFFFFF4D', padding: '10px' }}>{event.industryLabel}</div>
                </div>

            }
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', margin: '20px', justifyContent: 'space-between', marginBottom: '20px', alignItems: 'center' }}>
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', height: '24px' }}>
                    <img src={require("../../static/img/Vector2.png")} style={{
                        width: '12.5px',
                        height: '20px', alignItems: 'center'
                    }} ></img>
                    <div style={{ color: '#FFFFFF', fontSize: '24px', fontWeight: 700, lineHeight: '24px', marginLeft: '5px', marginRight: '5px' }}>
                        {event.eventNumber}
                    </div>
                    <div style={{ color: '#FFFFFF', fontSize: '16px', lineHeight: '24px' }} >{t('peoplewillgo')}</div>
                </div>
            </div>



            {!go ?
                <div style={{ width: '70px', height: '48px', backgroundColor: '#735BF2', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => ScrollContext2()}>
                    {/* <div style={{ color: '#fff', lineHeight: '48px', textAlign: 'center', fontWeight: 500, cursor: 'pointer' }}> +1 {t('GO')}</div>
                     */}
                    <img src={require("../../static/img/ic_round-favorite.png")} style={{ width: '24px', height: '24px' }}></img>

                </div>
                : <div onClick={() => {
                    goto({
                        sdmUserId: sdmUserIdref.current,
                        eventId: event.eventId
                    }).then((res) => {
                        if (res.code == 200) {
                            getgo(false)
                            getDate()
                            // whether()
                        } else {
                            cusBgNotify(res.msg)
                        }

                    });
                }} style={{
                    display: 'flex', width: '70px', height: '48px', backgroundColor: '#9788E7', borderRadius: '10px',
                    flexDirection: 'row', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'
                }}>
                    {/* <img src={require("../../static/img/Select2.png")} style={{ width: '16px', height: '16px', marginRight: '10px' }}></img>
                    <div style={{ color: '#fff', lineHeight: '48px', textAlign: 'center', fontWeight: 500 }}>{t('GO')}</div> */}
                    <img src={require("../../static/img/Vector4x.png")} style={{ width: '24px', height: '24px' }}></img>
                </div>
            }



        </div>

        <div style={{ marginTop: '20px', paddingBottom: '100px' }}>
            {businessCard.length > 3 || sys.length > 6 ? <div style={{ overflow: 'hidden', height: '60vh' }}>

                <div ref={containerRef} style={{ overflow: 'auto', height: '100%', overflowY: 'scroll' }}>
                    <div >
                        {
                            businessCard.map((item: any, index: any) => <div >
                                <div style={{ alignItems: 'center', marginBottom: 10, position: 'relative', marginLeft: '20px', marginRight: '20px', }}>
                                    <div style={{ backgroundImage: `url(${item.bgimg ? item.bgimg : bg1})`, width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '18px' }}>

                                        {/* onClick={() => Jumptobusinesscard(item.cardNo)} */}
                                        {/* <Link to={cardurl + '?st=sdn&id=' + item.cardNo + '&event=' + event.eventId}> */}
                                        <a href={cardurl + '?st=sdn&id=' + item.cardNo + '&event=' + event.eventId}>
                                            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 20, paddingTop: '20px', cursor: 'pointer' }}>
                                                {
                                                    item.userImg.length > 7 ? <img src={item.userImg} style={{ width: '72px', height: '72px', borderRadius: '18px', border: '4px solid #000', boxShadow: '5px 5px #000' }} ></img> :
                                                        <div style={{
                                                            width: '72px', height: '72px', lineHeight: '72px', borderRadius: '18px',
                                                            border: '4px solid #000', boxShadow: '5px 5px #000',
                                                            textAlign: 'center', backgroundColor: item.color ? item.color : '#ffaa7f', fontSize: '28px'
                                                        }}> {item.userName != null ? item.userName.slice(0, 1).toUpperCase() : ''}</div>
                                                }


                                                <div style={{ marginLeft: 10 }}>
                                                    <div style={{ fontSize: '24px', fontWeight: 700, color: '#FFFFFF', marginBottom: 2 }}>{item.name}</div>
                                                    <div style={{ fontSize: '16px', fontWeight: 500, color: '#FFFFFF', marginBottom: 2 }} >{item.title}</div>
                                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                        <img src={require("../../static/img/mianxing-gongsi.png")} style={{ width: '14px', height: '14px' }} ></img>
                                                        <div style={{ fontSize: '12px', color: '#FFFFFF', lineHeight: '14px', marginLeft: 5 }}>{item.company}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {item.friend == 1 && <div style={{ position: 'absolute', top: 10, right: 10 }}>
                                                <div style={{ backgroundColor: '#000', opacity: 0.5, height: '30px', borderRadius: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                    <img src={require("../../static/img/Vector4.png")} style={{ width: '14px', height: '14px', marginLeft: 8, marginRight: 8 }} ></img>
                                                    <div style={{ color: '#FFF', lineHeight: '30px', fontSize: '15px', marginRight: 8 }}>{t('Friend')}</div>
                                                </div>
                                            </div>
                                            }


                                            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                                {
                                                    item.cardIndustries.map((item2: any, ind: number) => <div key={ind} style={{ backgroundColor: 'rgba(0,0,0,0.5)', height: '24px', borderRadius: '12px', borderColor: '#fff', borderWidth: 1, margin: '2.5px', border: '1px solid #fff ' }}>
                                                        <div style={{ color: '#FFF', lineHeight: '24px', fontSize: '12px', marginLeft: 8, marginRight: 8 }}>#{item2.industry}</div>
                                                    </div>

                                                    )
                                                }
                                            </div>
                                        </a>
                                    </div>

                                </div>
                            </div>


                            )
                        }
                        {
                            sys.map((item: any, index: any) => <div key={index} style={{
                                display: 'flex', flexDirection: 'row',
                                marginLeft: '20px', marginRight: '20px', marginTop: 5, marginBottom: 10, backgroundColor: '#2F3237', borderRadius: 10,
                                justifyContent: 'space-between', alignItems: 'center', height: '64px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'row', margin: '8px', alignItems: 'center' }}>

                                    {/* <img src={item.imgUrl} style={{ width: '48px', height: '48px', borderColor: '#a2a2a2', borderWidth: 4, borderRadius: 8 }} ></img> */}
                                    {
                                        item.imgUrl.length > 7 ? <img src={item.imgUrl} style={{ width: '48px', height: '48px', borderColor: '#a2a2a2', borderWidth: 4, borderRadius: 8 }} ></img> :
                                            <div style={{
                                                width: '48px', height: '48px', lineHeight: '48px',
                                                textAlign: 'center', backgroundColor: item.color ? item.color : '#ffaa7f', fontSize: '20px', borderWidth: 4, borderRadius: 8
                                            }}> {item.sdmUserName != null ? item.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                    }

                                    <div style={{ marginLeft: 10 }}>
                                        <div style={{ fontWeight: 500, fontSize: '16px', color: '#FFFFFF', height: '24px', lineHeight: '24px' }}>
                                            {item.sdmUserName}
                                        </div>
                                        {/* <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                                            {item.sdmUserId.slice(0, 4)}...{item.sdmUserId.slice(item.sdmUserId.length - 4, item.sdmUserId.length)}
                                        </div> */}
                                        {
                                            item.walletDdressEtamask ? <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                                                {item.walletDdressEtamask.toString().slice(0, 4)}...{item.walletDdressEtamask.toString().slice(item.walletDdressEtamask.toString().length - 4, item.walletDdressEtamask.toString().length)}

                                            </div> : <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                                                {''}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {
                                    item.friend == 1 && <div style={{ marginRight: 10 }} >
                                        <div style={{ backgroundColor: '#000', opacity: 0.5, height: '30px', borderRadius: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <img src={require("../../static/img/Vector4.png")} style={{ width: '14px', height: '14px', marginLeft: 8, marginRight: 8 }} ></img>
                                            <div style={{ color: '#FFF', lineHeight: '30px', fontSize: '15px', marginRight: 8 }}>{t('Friend')}</div>

                                        </div>
                                    </div>
                                }
                            </div>)
                        }

                    </div>
                </div>
            </div> : <div>

                <div ref={containerRef}>
                    <div >
                        {
                            businessCard.map((item: any, index: any) => <div >
                                <div style={{ alignItems: 'center', marginBottom: 10, position: 'relative', marginLeft: '20px', marginRight: '20px', }}>
                                    <div style={{
                                        backgroundImage: `url(${item.bgimg ? item.bgimg : bg1})`, width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center',
                                        borderRadius: '18px'
                                    }}>


                                        <div onClick={() => Jumptobusinesscard(item.cardNo)} style={{ display: 'flex', flexDirection: 'row', marginLeft: 20, paddingTop: '20px', cursor: 'pointer' }}>
                                            {
                                                item.userImg.length > 7 ? <img src={item.userImg} style={{
                                                    width: '72px', height: '72px', borderRadius: '18px', border: '4px solid #000',
                                                    boxShadow: '5px 5px #000'
                                                }} ></img> :
                                                    <div style={{
                                                        width: '72px', height: '72px', lineHeight: '72px', borderRadius: '18px', border: '4px solid #000', boxShadow: '5px 5px #000',
                                                        textAlign: 'center', backgroundColor: item.color ? item.color : '#ffaa7f', fontSize: '28px'
                                                    }}> {item.userName != null ? item.userName.slice(0, 1).toUpperCase() : ''}</div>
                                            }


                                            <div style={{ marginLeft: 10 }}>
                                                <div style={{ fontSize: '24px', fontWeight: 700, color: '#FFFFFF', marginBottom: 2 }}>{item.name}</div>
                                                <div style={{ fontSize: '16px', fontWeight: 500, color: '#FFFFFF', marginBottom: 2 }} >{item.title}</div>
                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                    <img src={require("../../static/img/mianxing-gongsi.png")} style={{ width: '14px', height: '14px' }} ></img>
                                                    <div style={{ fontSize: '12px', color: '#FFFFFF', lineHeight: '14px', marginLeft: 5 }}>{item.company}</div>
                                                </div>
                                            </div>
                                        </div>

                                        {item.friend == 1 && <div style={{ position: 'absolute', top: 10, right: 10 }}>
                                            <div style={{ backgroundColor: '#000', opacity: 0.5, height: '30px', borderRadius: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <img src={require("../../static/img/Vector4.png")} style={{ width: '14px', height: '14px', marginLeft: 8, marginRight: 8 }} ></img>
                                                <div style={{ color: '#FFF', lineHeight: '30px', fontSize: '15px', marginRight: 8 }}>{t('Friend')}</div>
                                            </div>
                                        </div>
                                        }


                                        <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                            {
                                                item.cardIndustries.map((item2: any, ind: number) => <div key={ind} style={{ backgroundColor: '#000', opacity: 0.5, height: '24px', borderRadius: '12px', borderColor: '#fff', borderWidth: 1 }}>
                                                    <div style={{ color: '#FFF', lineHeight: '24px', fontSize: '12px', marginLeft: 8, marginRight: 8 }}>#{item2.industry}</div>
                                                </div>

                                                )
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>


                            )
                        }
                        {
                            sys.map((item: any, index: any) => <div key={index} style={{
                                display: 'flex', flexDirection: 'row',
                                marginLeft: '20px', marginRight: '20px', marginTop: 5, marginBottom: 10, backgroundColor: '#2F3237', borderRadius: 10,
                                justifyContent: 'space-between', alignItems: 'center', height: '64px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'row', margin: '8px', alignItems: 'center' }}>

                                    {/* <img src={item.imgUrl} style={{ width: '48px', height: '48px', borderColor: '#a2a2a2', borderWidth: 4, borderRadius: 8 }} ></img> */}
                                    {
                                        item.imgUrl.length > 7 ? <img src={item.imgUrl} style={{
                                            width: '48px', height: '48px',
                                            borderColor: '#a2a2a2', borderWidth: 4, borderRadius: 8
                                        }} ></img> :
                                            <div style={{
                                                width: '48px', height: '48px', lineHeight: '48px',
                                                textAlign: 'center', backgroundColor: item.color ? item.color : '#ffaa7f', fontSize: '20px', borderWidth: 4, borderRadius: 8
                                            }}> {item.sdmUserName != null ? item.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                    }

                                    <div style={{ marginLeft: 10 }}>
                                        <div style={{ fontWeight: 500, fontSize: '16px', color: '#FFFFFF', height: '24px', lineHeight: '24px' }}>
                                            {item.sdmUserName}
                                        </div>
                                        {/* <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                                            {item.sdmUserId.slice(0, 4)}...{item.sdmUserId.slice(item.sdmUserId.length - 4, item.sdmUserId.length)}
                                        </div> */}
                                        {
                                            item.walletDdressEtamask ? <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                                                {item.walletDdressEtamask.toString().slice(0, 4)}...{item.walletDdressEtamask.toString().slice(item.walletDdressEtamask.toString().length - 4, item.walletDdressEtamask.toString().length)}

                                            </div> : <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                                                {''}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {
                                    item.friend == 1 && <div style={{ marginRight: 10 }} >
                                        <div style={{ backgroundColor: '#000', opacity: 0.5, height: '30px', borderRadius: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <img src={require("../../static/img/Vector4.png")} style={{ width: '14px', height: '14px', marginLeft: 8, marginRight: 8 }} ></img>
                                            <div style={{ color: '#FFF', lineHeight: '30px', fontSize: '15px', marginRight: 8 }}>{t('Friend')}</div>

                                        </div>
                                    </div>
                                }
                            </div>)
                        }

                    </div>
                </div>
            </div>}

            <div style={{ backgroundColor: '#000' }}>
                <Content4></Content4>
            </div>
        </div>

        {
            go ?
                <div style={{
                    position: 'fixed', bottom: 0, left: 0, width: '100%', backgroundColor: '#000', display: 'flex',
                    flexDirection: 'row', justifyContent: 'center', cursor: 'pointer'
                }}>
                    <div style={{ display: 'flex', margin: '16px', alignItems: 'center' }}>
                        <div style={{
                            width: '285px', height: '48px', backgroundColor: '#FC774C',
                            color: '#FFF', fontSize: '16px', fontWeight: 500, textAlign: 'center', lineHeight: '48px', borderRadius: '10px',
                            display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center'
                        }} onClick={() => Directions(event.ticketingLink)}>
                            <img src={require("../../static/img/solar_ticket-bold.png")} style={{ width: '20px', height: '20px', marginRight: '10px' }}></img>
                            {t('Tickets')}</div>
                        <div onClick={() => getRoomInfo(event.registrationLink)} style={{
                            width: '48px', height: '48px', backgroundColor: '#50545A',
                            borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '20px', cursor: 'pointer'
                        }}>
                            <img src={require("../../static/img/Chat.png")} style={{ width: '20px', height: '20px' }}></img>
                        </div>
                    </div>

                </div> :
                <div style={{
                    position: 'fixed', bottom: 0, left: 0, width: '100%', backgroundColor: '#000', display: 'flex', flexDirection: 'row',
                    justifyContent: 'center', alignItems: 'center', cursor: 'pointer'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '16px' }}>
                        <div onClick={() => getRoomInfo(event.registrationLink)} style={{
                            width: '350px', height: '48px', backgroundColor: '#FC774C',
                            color: '#FFF', fontSize: '16px', fontWeight: 500, textAlign: 'center', lineHeight: '48px', borderRadius: '10px',
                            display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center', cursor: 'pointer'
                        }}>  <img src={require("../../static/img/Chat.png")} style={{ width: '20px', height: '20px', marginRight: '10px' }}></img>
                            {t('Joingroupchat')}
                        </div>

                    </div>
                </div>
        }
        {/* {
            totalref.current >= papticipant.length && <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        } */}
    </div >
};





function Content4() {
    const params = useParams()

    const [search, setsearch] = useSearchParams()
    const [eventId, seteventId] = useState(search.get("eventId"));
    // const [recommendationsdata, setrecommendations] = useState([]) as any;
    const [nearby, setnearby] = useState('') as any;
    const [similarAttendees, setsimilarAttendees] = useState('') as any;
    const [ft, setft] = useState(false);
    const getDate = () => {
        recommendations({
            // id: params.eventId,
            id: eventId,
            // id:159,
            distance: 50
        }).then((res) => {

            let data = geif()

            if (res.data.nearby) {
                res.data.nearby.time = gettime2(res.data.nearby.eventStartTime, res.data.nearby.eventEndTime)
                res.data.nearby.people = 0

                if (res.data.nearby.sdmUsers === null) {
                    res.data.nearby.sdmUsers = []

                } else {
                    res.data.nearby.sdmUsers.forEach((i: any) => {
                        i.c = color16()
                        i.imgUrl = i.imgUrl + ''
                    })
                }

                eventperson({
                    linUserIds: data,
                    eventId: res.data.nearby.eventId
                }).then((re) => {

                    if (re.data) {
                        res.data.nearby.people = re.data.friends
                    }

                    setnearby(res.data.nearby)
                    setft(true)
                })
            }



            if (res.data.similarAttendees) {
                res.data.similarAttendees.time = gettime2(res.data.similarAttendees.eventStartTime, res.data.similarAttendees.eventEndTime)
                res.data.similarAttendees.people = 0
                if (res.data.similarAttendees.sdmUsers === null) {
                    res.data.similarAttendees.sdmUsers = []
                } else {
                    console.log('res.data.similarAttendees')
                    res.data.similarAttendees.sdmUsers.forEach((i: any) => {
                        i.c = color16()
                        i.imgUrl = i.imgUrl + ''
                    })
                }
                eventperson({
                    linUserIds: data,
                    eventId: res.data.similarAttendees.eventId
                }).then((re) => {
                    // setrecommendations(res.data)
                    if (re.data) {
                        res.data.similarAttendees.people = re.data.friends
                    }
                    setsimilarAttendees(res.data.similarAttendees)
                    setft(true)
                })
            }


        }
        );
    }

    const color16 = () => {
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        // var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
        var color = 'rgb(' + r + ',' + g + ', ' + b + ')';
        let color2 = localStorage.getItem('randomcolor')
        return color
    }


    const geif = () => {
        const data: any = []
        let data2: any = []
        data2 = localStorage.getItem('getMyContacts')
        data2 = JSON.parse(data2)
        let Frienddata = data2 ? data2 : []
        if (Frienddata.length > 0) {

            data2.forEach((item: any) => {
                data.push(item.userId)
            })
        }
        return data
    }





    let [country, setcountry] = useState(localStorage.getItem('country'))

    useEffect(() => {
        getDate()
    }, []);
    const { t } = useTranslation();

    return <div style={{ padding: '20px', backgroundColor: '#202225' }}>
        {
            ft &&
            <div>
                <div style={{ display: 'flex', height: '20px', margin: '20px' }}>
                    <img src={require("../../static/img/tuijian.png")} alt="" style={{ height: '20px', width: '20px', marginRight: '5px' }} />
                    <div style={{ height: '20px', lineHeight: '20px' }}>{t('Recommendedtoyou')}</div>
                </div>

                {
                    nearby.eventId && <div>
                        
                        <Link to={`${nearby.eventPid ==0?'/eventdetails':'/Details2'}?eventId=${nearby.eventId}&country=${country}`
                        }
                            style={{ color: '#FFF', textDecorationLine: 'none', }}

                        >
                            <div style={{
                                backgroundColor: '#202225',
                                alignItems: 'center',
                                // position: 'relative',
                                borderRadius: '20px',
                                // padding: '20px',
                                marginTop: '10px',
                                paddingTop: 0
                            }}>
                                <div style={{
                                    width: '100%',
                                    borderRadius: '20px',
                                    backgroundColor: '#35363B',
                                    position: 'relative',
                                }}>

                                    <div style={{ height: '100px', overflow: 'hidden', }}>
                                        <img src={nearby.eventBanner} style={{
                                            width: '100%',
                                            borderTopRightRadius: '20px',
                                            borderTopLeftRadius: '20px',
                                        }} alt="" />

                                        {
                                            nearby.eventCountry && <div style={{
                                                display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                                                borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                                right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                            }}>
                                                <img src={require("../../static/img/Vector3.png")} style={{
                                                    width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                                }} alt="" />
                                                {/* {nearby.eventCountry} */}
                                                {t('Nearby')}
                                            </div>
                                        }

                                    </div>
                                    {nearby.sideNumber != 0 && nearby.sideNumber &&

                                        <div style={{
                                            display: 'flex', height: '30px', lineHeight: '30px',
                                            backgroundColor: '#212327', borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                            right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                        }}>
                                            <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                                                width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                            }} alt="" />
                                            {nearby.sideNumber} {t('Sideevents')}
                                        </div>
                                    }


                                    <div style={{ margin: 10 }}>
                                        {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, }}>{t('NYCFallEvents')}</div> */}
                                        <div style={{
                                            fontSize: '24px', fontWeight: 700, padding: 5, overflow: 'hidden',
                                            textOverflow: 'ellipsis',whiteSpace: 'nowrap', width: '95%'
                                        }}>{nearby.eventName}</div>
                                        <div style={{
                                            color: '#8E929D',
                                            fontSize: '14px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            <img src={require("../../static/img/Date.png")} style={{
                                                marginLeft: '5px',
                                                marginRight: '5px',
                                                width: '14px',
                                                height: '14px'
                                            }}></img> {nearby.time}
                                            {/* {t('6November-7November')} */}
                                        </div>
                                        <Link to={`/plat2?longitude=${nearby.longitude}&latitude=${nearby.latitude}&eventLocation=${nearby.eventLocation}&eventName=${nearby.eventName}&time=${nearby.time}&eventId=${nearby.eventId}`}
                                            style={{ color: '#FFF', textDecorationLine: 'none' }}
                                        >
                                            <div style={{
                                                color: '#8E929D',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                paddingTop: '5px'
                                                , overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'
                                            }}>
                                                <img src={require("../../static/img/tdesign_location.png")} style={{
                                                    marginLeft: '5px',
                                                    marginRight: '5px',
                                                    width: '14px',
                                                    height: '14px',
                                                    // paddingTop: '5px'
                                                }}></img>
                                                <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{nearby.eventLocation}</span>
                                                {/* {t('NewYork,UnitedStates')} */}
                                            </div>
                                        </Link>
                                    </div>
                                    <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                                        <div style={{ display: 'flex' }}>
                                            <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                                                {/* //待定 */}


                                                {nearby.sdmUsers.map((item2: any, index: number) => <div>
                                                    {
                                                        index < 4 && <div>
                                                            {
                                                                item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index} style={{
                                                                    width: '24px', height: '24px', alignSelf: 'center', borderRadius: '12px'
                                                                    , position: 'absolute', left: index * 14, border: '2px solid #2F3039'
                                                                }} alt="" /> :
                                                                    <div key={index} style={{
                                                                        width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px',
                                                                        position: 'absolute', left: index * 14, textAlign: 'center',
                                                                        backgroundColor: item2.c, color: '#fff', border: '2px solid #2F3039', fontSize: '16px'
                                                                    }} >{item2.sdmUserName ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                                            }

                                                        </div>
                                                    }
                                                    {
                                                        index == 4 && <img src={require("../../static/img/Group.png")} key={index} style={{
                                                            width: '24px', height: '24px',
                                                            position: 'absolute', left: 56, alignSelf: 'center', borderRadius: '12px'
                                                        }}></img>
                                                    }
                                                </div>
                                                )}
                                            </div>
                                            {/* {item.people > 0 &&
                              <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px' }}>
                                  {item.people}{t('friendswillgo')}
                              </div>
                          } */}

                                        </div>
                                        {nearby.people > 0 &&
                                            <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                                                <span style={{ marginRight: '5px' }}> {nearby.people}</span>{t('friendswillgo')}
                                            </div>
                                        }
                                        <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                                            <img src={require("../../static/img/Vector2.png")} style={{
                                                width: '12.5px',
                                                height: '20px', marginRight: '5px'
                                            }} ></img>
                                            {nearby.eventNumber ? nearby.eventNumber : 0}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>

                }

                {
                    similarAttendees.eventId && <Link to={`${similarAttendees.eventPid ==0?'/eventdetails':'/Details2'}?eventId=${similarAttendees.eventId}&country=${country}`
                    }
                        style={{ color: '#FFF', textDecorationLine: 'none', }}

                    >
                        <div style={{
                            backgroundColor: '#202225',
                            alignItems: 'center',
                            // position: 'relative',
                            borderRadius: '20px',
                            // padding: '20px',
                            marginTop: '10px',
                            paddingTop: 0
                        }}>
                            <div style={{
                                width: '100%',
                                borderRadius: '20px',
                                backgroundColor: '#35363B',
                                position: 'relative',
                            }}>
                                <div style={{ height: '100px', overflow: 'hidden', }}>
                                    <img src={similarAttendees.eventBanner} style={{
                                        width: '100%',
                                        borderTopRightRadius: '20px',
                                        borderTopLeftRadius: '20px',
                                    }} alt="" />

                                    <div style={{
                                        display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                                        borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                        right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                    }}>
                                        <img src={require("../../static/img/Vector2.png")} style={{
                                            width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                        }} alt="" />
                                        {t('similarAttendees')}
                                    </div>


                                </div>
                                {similarAttendees.sideNumber != 0 && similarAttendees.sideNumber &&

                                    <div style={{
                                        display: 'flex', height: '30px', lineHeight: '30px',
                                        backgroundColor: '#212327', borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                        right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                    }}>
                                        <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                                            width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                        }} alt="" />
                                        {similarAttendees.sideNumber} {t('Sideevents')}
                                    </div>
                                }


                                <div style={{ margin: 10 }}>
                                    {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, }}>{t('NYCFallEvents')}</div> */}
                                    <div style={{
                                        fontSize: '24px', fontWeight: 700, padding: 5, overflow: 'hidden',
                                        textOverflow: 'ellipsis',whiteSpace: 'nowrap', width: '95%'
                                    }}>{similarAttendees.eventName}</div>
                                    <div style={{
                                        color: '#8E929D',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <img src={require("../../static/img/Date.png")} style={{
                                            marginLeft: '5px',
                                            marginRight: '5px',
                                            width: '14px',
                                            height: '14px'
                                        }}></img> {similarAttendees.time}
                                        {/* {t('6November-7November')} */}
                                    </div>
                                    <Link to={`/plat2?longitude=${similarAttendees.longitude}&latitude=${similarAttendees.latitude}&eventLocation=${similarAttendees.eventLocation}&eventName=${similarAttendees.eventName}&time=${similarAttendees.time}&eventId=${similarAttendees.eventId}`}
                                        style={{ color: '#FFF', textDecorationLine: 'none' }}
                                    >
                                        <div style={{
                                            color: '#8E929D',
                                            fontSize: '14px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingTop: '5px'
                                            , overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'
                                        }}>
                                            <img src={require("../../static/img/tdesign_location.png")} style={{
                                                marginLeft: '5px',
                                                marginRight: '5px',
                                                width: '14px',
                                                height: '14px',
                                                // paddingTop: '5px'
                                            }}></img>
                                            <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{similarAttendees.eventLocation}</span>
                                            {/* {t('NewYork,UnitedStates')} */}
                                        </div>
                                    </Link>
                                </div>
                                <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                                            {/* //待定 */}
                                            {similarAttendees.sdmUsers.map((item2: any, index: number) => <div>
                                                {
                                                    index < 4 && <div>
                                                        {
                                                            item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index} style={{
                                                                width: '24px', height: '24px', alignSelf: 'center', borderRadius: '12px'
                                                                , position: 'absolute', left: index * 14, border: '2px solid #2F3039'
                                                            }} alt="" /> :
                                                                <div key={index} style={{
                                                                    width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px',
                                                                    position: 'absolute', left: index * 14, textAlign: 'center',
                                                                    backgroundColor: item2.c, color: '#fff', border: '2px solid #2F3039', fontSize: '16px'
                                                                }} >{item2.sdmUserName ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                                        }

                                                    </div>
                                                }
                                                {
                                                    index == 4 && <img src={require("../../static/img/Group.png")} key={index} style={{
                                                        width: '24px', height: '24px',
                                                        position: 'absolute', left: 56, alignSelf: 'center', borderRadius: '12px'
                                                    }}></img>
                                                }
                                            </div>
                                            )}
                                        </div>
                                        {/* {item.people > 0 &&
                                                <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px' }}>
                                                    {item.people}{t('friendswillgo')}
                                                </div>
                                            } */}

                                    </div>
                                    {similarAttendees.people > 0 &&
                                        <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                                            <span style={{ marginRight: '5px' }}> {similarAttendees.people}</span>{t('friendswillgo')}
                                        </div>
                                    }
                                    <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                                        <img src={require("../../static/img/Vector2.png")} style={{
                                            width: '12.5px',
                                            height: '20px', marginRight: '5px'
                                        }} ></img>
                                        {similarAttendees.eventNumber ? similarAttendees.eventNumber : 0}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                }


                {/* )
                } */}
            </div>
        }

    </div>
}



export default EventDetails;